import {
  OurClient1,
  OurClient2,
  OurClient3,
  OurClient4,
  OurClient5,
  OurClient6,
  OurClient7,
  OurClient8,
  OurClient9,
} from '@/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Marquee from 'react-fast-marquee';
const SectionOurClient = () => {
  const { t } = useTranslation();
  const listLogo = [
    <OurClient1 />,
    <OurClient2 />,
    <OurClient3 />,
    <OurClient4 />,
    <OurClient5 />,
    <OurClient6 />,
    <OurClient7 />,
    <OurClient8 />,
    <OurClient9 />,
  ];
  return (
    <div className="section-our-client">
      <p className="title-section">{t('Our Clients')}</p>
      <p className="desc">
        {t(
          'With a proven track record and a dedicated team, Warppipe delivers reliable, high-quality outsourcing services tailored to your business needs. Partner with us to scale faster, innovate smarter, and stay ahead of the curve.'
        )}
      </p>
      <Marquee>
        {listLogo.map((item, index) => (
          <div className="logo" key={index}>
            {item}
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default React.memo(SectionOurClient);
